<template>
  <b-card>
    <b-row>
      <div v-for="x in charts" v-bind:key="x.index" class="col-md-3 mt-5">
        <b-card
          :img-src="'/media/Charts/' + x.index + '.jpg'"
          img-alt="Image"
          img-top
          :title="x.name"
          style="cursor:pointer"
          @click="save(x)"
        >
        </b-card>
      </div>
    </b-row>
  </b-card>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
export default {
  name: "NewChart",
  data() {
    return {
      charts: [
        {
          index: 1,
          conditions: [],
          mdid100_type: 1652,
          name: "نمودار خطی مجموع پرداختی های هر روز",
          source_id: 1,
          xAxis: "persian_date",
          yAxis: [
            {
              name: "مجموع پرداختی",
              field_name: "cost",
              field_type: "sum",
            },
          ],
        },
        {
          index: 2,
          conditions: [],
          mdid100_type: 1652,
          name: "نمودار خطی تعداد تراکنش ها در روز",
          source_id: 1,
          xAxis: "persian_date",
          yAxis: [
            {
              name: " تعداد تراکنش",
              field_name: "cost",
              field_type: "length",
            },
          ],
        },
        {
          index: 3,
          conditions: [],
          mdid100_type: 1652,
          name: "نمودار خطی مجموع پرداختی های هر ماه",
          source_id: 1,
          xAxis: "month",
          yAxis: [
            {
              name: "مجموع پرداختی",
              field_name: "cost",
              field_type: "sum",
            },
          ],
        },
        {
          index: 4,
          conditions: [],
          mdid100_type: 1652,
          name: "نمودار خطی تعداد تراکنش ها در ماه",
          source_id: 1,
          xAxis: "month",
          yAxis: [
            {
              name: " تعداد تراکنش",
              field_name: "cost",
              field_type: "length",
            },
          ],
        },
        {
          index: 5,
          conditions: [],
          mdid100_type: 1652,
          name: "نمودار خطی مجموع پرداختی های هر سال",
          source_id: 1,
          xAxis: "year",
          yAxis: [
            {
              name: "مجموع پرداختی",
              field_name: "cost",
              field_type: "sum",
            },
          ],
        },
        {
          index: 6,
          conditions: [],
          mdid100_type: 1652,
          name: "نمودار خطی تعداد تراکنش ها در سال",
          source_id: 1,
          xAxis: "year",
          yAxis: [
            {
              name: " تعداد تراکنش",
              field_name: "cost",
              field_type: "length",
            },
          ],
        },
        {
          index: 7,
          conditions: [],
          mdid100_type: 1654,
          name: "نمودار دایره ای تعداد تراکنش ها در هفته",
          source_id: 1,
          xAxis: "dayofweek",
          yAxis: [
            {
              name: " تعداد تراکنش",
              field_name: "cost",
              field_type: "length",
            },
          ],
        },
        {
          index: 8,
          conditions: [],
          mdid100_type: 1654,
          name: "نمودار دایره ای مجموع تراکنش ها در هفته",
          source_id: 1,
          xAxis: "dayofweek",
          yAxis: [
            {
              name: " تعداد تراکنش",
              field_name: "cost",
              field_type: "sum",
            },
          ],
        },
        {
          index: 9,
          conditions: [],
          mdid100_type: 1710,
          name: "نمودار حرارتی تعداد تراکنش ها نسبت به ساعت در روز های هفته",
          source_id: 1,
          xAxis: "dayofweek",
          yAxis: [
            {
              name: " تعداد تراکنش",
              field_name: "cost",
              field_type: "length",
            },
          ],
        },
      ],
    };
  },
  mounted() {},
  methods: {
    save(bi) {
      httpHelper.postData("BI", bi).then((res) => {
        this.$router.push("/reports");
      });
    },
  },
};
</script>